<ng-container *ngIf="canShowTitle$ | async">
  <h2>Account Selection</h2>
  <p>
    Here are the accounts you've selected so far.
    {{
      (canShowMultiproductMessage$ | async)
        ? "Review your selections and add any other accounts you want to open."
        : ""
    }}
  </p>
</ng-container>
<p class="error" *ngIf="canShowErrorMessage$ | async">
  One or more of your accounts requires attention. Update to proceed.
</p>
<ng-template #accountSelection></ng-template>
<div *ngIf="(canAddAccount$ | async) && !isAccountSelectionOpen">
  <app-icon-button
    icon="add_circle"
    label="Add account"
    (click)="addAccountSelector()"
  ></app-icon-button>
  <span class="button-detail"
    >Save time - open more than one account during your application
    session.</span
  >
</div>
